import { render, staticRenderFns } from "./AccountsCards.vue?vue&type=template&id=21c3b35c"
import script from "./AccountsCards.vue?vue&type=script&lang=js"
export * from "./AccountsCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports